module.exports = __webpack_public_path__ + "static/media/coverpage.27b670fe.png";